import React from "react";
import { useSelector } from "react-redux";
import { useValidateMotUsingDecType,useValidateNationalityUsingMot } from "../../../hooks/AGS";
import { typeIdKey } from "../../../util/NL_fieldPatterns";


const BorderTransportMode=({saveData,onUpdate,renderForm,title,modeType,isImportShipment,validate,validateError,fieldPattern})=>{
 
  const dataSource=useSelector((state)=>state.Shipment.transportation[modeType])

  const motError=useValidateMotUsingDecType(dataSource.mot,validateError)
  const typeIdError=useSelector((state)=>state.ValidationErrors.header?.[typeIdKey]?.msg)
  const {validationMsg,isTransNationalityVisible }=useValidateNationalityUsingMot(isImportShipment,dataSource.mot)
  
  const OnMotChange=({value,...rest})=>{
    if(["2","5","7"].includes(value) && !isImportShipment){
      saveData({mot:value,nationality:" ",...rest})
      onUpdate({mot:value?.trim(),nationality:"",...rest})
    }

    else{
          saveData({mot:value,...rest})
          onUpdate({mot:value?.trim(),...rest})
        }
   
  }
 



  
 return renderForm && renderForm(
     {
        title,
        modeType,
        hideFields:{transportId:true,type:true},
        disableFields:{nationality:isTransNationalityVisible},
        errorInfo:{mot:motError,typeId:typeIdError},
        validationMsg,
        dataSource,
        saveData,
        onUpdate,
        onMotChange:OnMotChange,
        fieldPattern,
        validateError
     }
 )

}

export default React.memo(BorderTransportMode)
